import script from "./AdminColumnsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminColumnsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminColumnsPage.vue?vue&type=style&index=0&id=141bb782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141bb782"]])

export default __exports__